import { Grid, Row, Tabs } from 'antd'
import CreateRental from 'app/components/Core/Project/CreateRental'
import Form from 'app/components/Core/Project/Form'
import Title from 'app/components/Core/Rental/Title'
import PullToRefresh from 'app/components/UI-Elements/General/PullToRefresh'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useShow } from 'app/lib/hooks/useApi'
import useSetBackHistory from 'app/lib/hooks/useSetBackHistory'
import useTitle from 'app/lib/hooks/useTitle'
import useTranslation from 'app/lib/hooks/useTranslation'
import Document from 'app/pages/Project/Containers/Document'
import Invoice from 'app/pages/Project/Containers/Invoice'
import Map from 'app/pages/Project/Containers/Map'
import Project from 'app/pages/Project/Containers/Project'
import Rental from 'app/pages/Project/Containers/Rental'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import ProjectPlan from '../Containers/ProjectPlan'

const { TabPane } = Tabs
const Show: React.FC<PageProps> = (props) => {
  const { titlelizer } = useTitle(props)
  const { tRoute } = useTranslation({ scope: props.route.key })
  const screens = Grid.useBreakpoint()

  const { setBackRoute } = useBrowserRouterContext()
  const { project_id } = useParams<{ project_id: string }>()
  const {
    modalify: { open, close }
  } = useFeedbacker()
  const { loading, response: project, execute } = useShow<IProject>(RecordType.project)
  const navigate = useNavigate()
  const location = useLocation()
  const { generateId, buttonId } = ToolBox.useId()
  const getId = (id: string) =>
    generateId({ recordType: RecordType.project, componentType: 'tab', id })

  useEffect(() => {
    loadProject()
  }, [])

  useSetBackHistory(() => setBackRoute(Routes.Project.collection().index))

  const loadProject = () => execute({ id: parseInt(project_id) })

  useEffect(() => {
    titlelizer({ name: project?.name })
  }, [project])

  const onChange = (key: string) => {
    navigate(key)
    setBackRoute(Routes.Project.collection().index)
  }

  const onSuccess = () => {
    loadProject()
    close()
  }

  const onClick = () => {
    open({
      destroyOnClose: true,
      title: project.name,
      recordType: RecordType.project,
      action: 'update',
      modalType: 'form',
      content: <Form props={{ onSuccess, onCancel: close }} member={project} />
    })
  }

  return (
    <Row>
      <KCol
        card
        span={24}
        loading={loading}
        cardProps={{
          extra: (
            <If condition={project && screens.lg}>
              <CreateRental
                props={{
                  id: buttonId({ recordType: RecordType.project, action: 'create_rental' })
                }}
                member={project}
              />
            </If>
          )
        }}
        title={
          <If condition={screens.lg}>
            <Title member={project} props={{ onClick }} />
          </If>
        }
      />
      <KCol span={24}>
        <Tabs
          activeKey={location.pathname}
          defaultActiveKey={Routes.Project.member(project_id).show}
          onChange={onChange}
          tabBarStyle={{ backgroundColor: 'white', padding: screens.md ? '0 24px' : '0 12px' }}>
          <TabPane
            tab={
              <span id={getId('overview')} className="px-2">
                {tRoute({ id: 'overview' })}
              </span>
            }
            key={Routes.Project.member(project_id).show}>
            <PullToRefresh onRefresh={loadProject}>
              <Project project={project} />
            </PullToRefresh>
          </TabPane>
          <TabPane
            tab={
              <span id={getId('rentals')} className="px-2">
                {tRoute({ id: 'rentals' })}
              </span>
            }
            key={Routes.Project.member(project_id).rental}>
            <Rental project={project} />
          </TabPane>
          <If condition={screens.lg}>
            <TabPane
              tab={
                <span id={getId('invoices')} className="px-2">
                  {tRoute({ id: 'invoices' })}
                </span>
              }
              key={Routes.Project.member(project_id).invoice}>
              <Invoice project={project} />
            </TabPane>
          </If>
          <TabPane
            tab={
              <span id={getId('documents')} className="px-2">
                {tRoute({ id: 'documents' })}
              </span>
            }
            key={Routes.Project.member(project_id).document}>
            <Document project={project} />
          </TabPane>
          <If condition={screens.lg}>
            <TabPane
              tab={
                <span id={getId('project_plan')} className="px-2">
                  {tRoute({ id: 'project_plan' })}
                </span>
              }
              key={Routes.Project.member(project_id).plan}>
              <ProjectPlan project={project} />
            </TabPane>
            <TabPane
              tab={
                <span id={getId('live_tracking')} className="px-2">
                  {tRoute({ id: 'live_tracking' })}
                </span>
              }
              key={Routes.Project.member(project_id).map}>
              <Map />
            </TabPane>
          </If>
        </Tabs>
      </KCol>
    </Row>
  )
}

export default Show
